import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Blog - Sustainability Content`('0.0.1')({
  gutterless: true,
  view: () => <UI.Modules.Page.Reusable value={ {path: '', name: 'Blog - Sustainability Content' } } />,
  edit: {}
});
